export default __webpack_public_path__ + "static/media/cart.adcbdee3.png";